<ng-template #portalContent>
  <mat-sidenav-container
    [hasBackdrop]="backdropEnabled"
    (backdropClick)="close()"
  >
    <mat-sidenav
      [fixedInViewport]="true"
      [opened]="opened$ | async"
      #sidenav
      class="drawer"
      [ngClass]="drawerEnlarged ? 'drawer-enlarged-width':'drawer-normal-width'"
      mode="over"
      position="end"
      (onClose)="close()"
      data-cy="side-nav-portal"
    >
      <div class="drawer-header">
        <div class="drawer-header-title">
          <mat-icon
            class="drawer-back-button"
            (click)="goBack()"
          >keyboard_arrow_left</mat-icon>
          <div
            class="drawer-close-button"
            data-cy="sidenav-close-button"
            (click)="close()"
          >
            <mat-icon class="close-mat-icon">close</mat-icon>
          </div>

          <ng-content select="[header-title]"></ng-content>
        </div>

        <div class="drawer-header-actions">
          <ng-content select="[header-actions]"></ng-content>
        </div>
      </div>
      <div class="drawer-content">
        <ng-content></ng-content>
      </div>
    </mat-sidenav>
  </mat-sidenav-container>
</ng-template>
